import {
  VehicleModel,
  VehicleModelRow,
} from "./types";

/*---------------------------------------------------------------------------------------
    VEHICLE MODEL SEARCH
  -----------------------------------------------------------------------------------------*/

export const transformVehicleModelRow = (res: any): VehicleModelRow => {
  return {
    id: res.id,
    name: res.name,
    image: res.image,
    year: res.yearFrom ?? null,
    yearFrom: res.yearFrom ?? null,
    yearTo: res.yearTo ?? null,
    manufacturerCode: res.manufacturerCode ?? null,
  };
};

/*---------------------------------------------------------------------------------------
      VEHICLE MODEL CREATE/EDIT
  -----------------------------------------------------------------------------------------*/

export const transformVehicleModel = (res: any): VehicleModel => {
  return {
    id: res.id,
    image: res.image,
    name: res.name,
    year: res.yearFrom ?? null,
    yearFrom: res.yearFrom ?? null,
    yearTo: res.yearTo ?? null,
  };
};
